<div *ngIf="hasTariff" class="mb-4">

    <div class="row pl-3 pr-3 mb-3 d-flex justify-content-around">
        <!-- users card -->
        <div class="col-lg-3 col-md-6 col-12 ">
            <div class="feature feature-four ">
                <p><strong>{{'tariff.fields.ref'|translate}} </strong></p>
                <p class="feature_desc">{{tariff.ref}} </p>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12 ">
            <div class="feature feature-four ">
                <p><strong>{{'tariff.fields.cpoTariffCoef'|translate}}</strong></p>
                <p class="feature_desc">{{tariff.cpoTariffCoef}} = {{tariff.cpoTariffCoef * 100}}% </p>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12 ">
            <div class="feature feature-four ">
                <p><strong>{{'tariff.fields.intermediationFees'|translate}}</strong></p>
                <p class="feature_desc">{{tariff.intermediationFees}} {{currentEnterpriseCurrency}}</p>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12 ">
            <div class="feature feature-four ">
                <p><strong>{{'tariff.fields.operatingFees'|translate}}</strong></p>
                <p class="feature_desc">{{tariff.operatingFees}} {{currentEnterpriseCurrency}} </p>
            </div>
        </div>
    </div>
</div>

<div>
    <p-panel header="{{'pages_titles.tariff' | translate}}">

        <app-loader *ngIf="loadingSpinner"></app-loader>

        <form [formGroup]="tariffForm" *ngIf="!loadingSpinner">
            <div class="row ml-3 mr-3">
                <!--  Reference -->
                <div class="form-group col-12 col-md-6">
                    <label for="ref" class="mt-2">{{'tariff.fields.ref'|translate}}<span
                            class="text-danger">*</span></label>
                    <input pInputText type="text" id="ref" formControlName="ref" class="w-100" />
                    <ng-container *ngIf="(ref.invalid) && (ref.dirty || ref.touched)">
                        <p class="text-danger d-flex justify-content-start" *ngIf="ref?.errors?.required">
                            {{'tariff.required.ref'| translate}}
                        </p>
                    </ng-container>
                </div>

                <!--  Cpo tariff coefficient -->
                <div class="form-group col-12 col-md-6">
                    <label for="cpoTariffCoef" class="mt-2">{{'tariff.fields.cpoTariffCoef'|translate}}<span
                            class="text-danger">*</span></label>

                    <p-inputNumber [style]="{'width': '100%'}" class="w-100" name="cpoTariffCoef" required
                        formControlName="cpoTariffCoef" [showButtons]="true" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="4">
                    </p-inputNumber>

                    <ng-container *ngIf=" (cpoTariffCoef.dirty || cpoTariffCoef.touched)">
                        <p class="text-danger d-flex justify-content-start" *ngIf="cpoTariffCoef?.errors?.required">
                            {{'tariff.required.cpoTariffCoef'| translate}}
                        </p>
                        <p class="text-danger d-flex justify-content-start" *ngIf="cpoTariffCoef.errors?.min">
                            {{ 'tariff.min.cpoTariffCoef' | translate }}
                        </p>
                        <p class="text-danger d-flex justify-content-start" *ngIf="cpoTariffCoef.errors?.max">
                            {{ 'tariff.max.cpoTariffCoef' | translate }}
                        </p>
                    </ng-container>
                </div>

                <!--  Intermediation fees -->
                <div class="form-group col-12 col-md-6">
                    <label for="intermediationFees" class="mt-2">{{'tariff.fields.intermediationFees'|translate}}<span
                            class="text-danger">*</span></label>
                    <p-inputNumber [style]="{'width': '100%'}" class="w-100" name="intermediationFees" required
                        formControlName="intermediationFees" [showButtons]="true" mode="currency" currency="EUR">
                    </p-inputNumber>

                    <ng-container
                        *ngIf="(intermediationFees.invalid) && (intermediationFees.dirty || intermediationFees.touched)">
                        <p class="text-danger d-flex justify-content-start"
                            *ngIf="intermediationFees?.errors?.required">
                            {{'tariff.required.intermediationFees'| translate}}
                        </p>
                    </ng-container>
                </div>

                <!--  Operating fees -->
                <div class="form-group col-12 col-md-6">
                    <label for="operatingFees" class="mt-2">{{'tariff.fields.operatingFees'|translate}}<span
                            class="text-danger">*</span></label>

                    <p-inputNumber [style]="{'width': '100%'}" class="w-100" name="operatingFees" required
                        formControlName="operatingFees" [showButtons]="true" mode="currency" currency="EUR">
                    </p-inputNumber>

                    <ng-container *ngIf="(operatingFees.invalid) && (operatingFees.dirty || operatingFees.touched)">
                        <p class="text-danger d-flex justify-content-start" *ngIf="operatingFees?.errors?.required">
                            {{'tariff.required.operatingFees'| translate}}
                        </p>
                    </ng-container>
                </div>

                <!--  Text in french -->
                <div class="form-group col-12">
                    <label for="textFr" class="mt-2">{{'tariff.fields.description.textFr'|translate}}<span
                            class="text-danger">*</span></label>
                    <textarea pInputTextarea id="textFr"
                        [status]="(textFr.dirty || textFr?.touched) ? ((textFr.invalid)  ? 'danger' : 'success') : 'basic'"
                        fullWidth formControlName="textFr" rows="4" cols="50" class="w-100"></textarea>
                    <ng-container *ngIf="(textFr.invalid) && (textFr.dirty || textFr.touched)">
                        <p class="text-danger d-flex justify-content-start" *ngIf="textFr?.errors?.required">
                            {{'tariff.required.description.textFr'| translate}}
                        </p>
                    </ng-container>
                </div>

                <!--  Text in english -->
                <div class="form-group col-12">
                    <label for="textEn" class="mt-2">{{'tariff.fields.description.textEn'|translate}}<span
                            class="text-danger">*</span></label>
                    <textarea pInputTextarea id="textEn"
                        [status]="(textEn.dirty || textEn?.touched) ? ((textEn.invalid)  ? 'danger' : 'success') : 'basic'"
                        fullWidth formControlName="textEn" rows="4" cols="50" class="w-100"></textarea>
                    <ng-container *ngIf="(textEn.invalid) && (textEn.dirty || textEn.touched)">
                        <p class="text-danger d-flex justify-content-start" *ngIf="textEn?.errors?.required">
                            {{'tariff.required.description.textEn'| translate}}
                        </p>
                    </ng-container>
                </div>

                <!--  Text in espagnol -->
                <div class="form-group col-12">
                    <label for="textEs" class="mt-2">{{'tariff.fields.description.textEs'|translate}}<span
                            class="text-danger">*</span></label>
                    <textarea pInputTextarea id="textEs"
                        [status]="(textEs.dirty || textEs?.touched) ? ((textEs.invalid)  ? 'danger' : 'success') : 'basic'"
                        fullWidth formControlName="textEs" rows="4" cols="50" class="w-100"></textarea>
                    <ng-container *ngIf="(textEs.invalid) && (textEs.dirty || textEs.touched)">
                        <p class="text-danger d-flex justify-content-start" *ngIf="textEs?.errors?.required">
                            {{'tariff.required.description.textEs'| translate}}
                        </p>
                    </ng-container>
                </div>

                <!--  Text in deutsch -->
                <div class="form-group col-12">
                    <label for="textAl" class="mt-2">{{'tariff.fields.description.textAl'|translate}}<span
                            class="text-danger">*</span></label>
                    <textarea pInputTextarea id="textAl"
                        [status]="(textAl.dirty || textAl?.touched) ? ((textAl.invalid)  ? 'danger' : 'success') : 'basic'"
                        fullWidth formControlName="textAl" rows="4" cols="50" class="w-100"></textarea>
                    <ng-container *ngIf="(textAl.invalid) && (textAl.dirty || textAl.touched)">
                        <p class="text-danger d-flex justify-content-start" *ngIf="textAl?.errors?.required">
                            {{'tariff.required.description.textAl'| translate}}
                        </p>
                    </ng-container>
                </div>

                <!--  Button add -->
                <div class="ml-auto mr-auto">
                    <button pButton icon="pi pi-check" iconPos="left" (click)="addOrUpdateTariff()"
                        [disabled]="tariffForm.invalid" type="button" label="{{'actions.update' | translate}}"></button>
                </div>

            </div>
        </form>

    </p-panel>
</div>